import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMiles } from '../../../helpers/format';

function HeaderHistory() {
  const { t } = useTranslation('card');

  return (
    <div className="corporate-club-extract__card__header history">
      <h3 className="corporate-club-extract__card__header__title">
        <span className="corporate-club-extract__card__header__title__icon-orange" />
        <span className="history-icon">Premiar Milhas</span>
      </h3>
    </div>
  );
}

export default HeaderHistory;
